import React from "react";
import { Button } from "../../../../../shadcn/components/ui/button";

interface GeneralInfoCardProps {
  icon: React.ReactNode; // Icon component
  title?: string;
  mainText?: string;
  subText?: string;
  buttonLabel?: string;
  buttonIcon?: React.ReactNode;
  onButtonClick?: () => void;
  styles?: {
    container?: string;
    title?: string;
    price?: string;
    subText?: string;
    button?: string;
  };
  onlySwissEventUser?: boolean;
}

export default function GeneralInfoCard({
  icon,
  title = "Default Title",
  mainText = "₹0",
  subText = "",
  buttonLabel = "Learn More",
  buttonIcon,
  onButtonClick,
  onlySwissEventUser = false,
  styles = {},
}: GeneralInfoCardProps) {
  const {
    container = "",
    title: titleStyle = "",
    price: priceStyle = "",
    subText: subTextStyle = "",
    button: buttonStyle = "",
  } = styles;

  return (
    <div
      className={`border border-[#EEE] p-3 xl:p-6 flex flex-col justify-between ${
        container || "bg-white"
      }`}
    >
      <div className=" mb-3 xl:mb-6">
        <div className="flex">
          <div className="bg-[#FEECE6] p-[7px] rounded-full">{icon}</div>
        </div>
        <div
          className={`mt-3 text-sm font-sans text-brand-textBlack max-w-[130px] ${titleStyle}`}
        >
          {title}
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div className="text-brand-textBlack">
          {subText && (
            <div
              className={`justify-self-end text-[8px] md:text-sm xl:text-base -mb-2 xl:-mb-1 ${subTextStyle}`}
            >
              {subText}
            </div>
          )}
          <div
            className={`text-2xl md:text-3xl xl:text-[45px] font-sans ${priceStyle}`}
          >
            {mainText}
          </div>
        </div>
        <Button
          disabled={onlySwissEventUser}
          className={`rounded-lg px-2 h-[34px] ${buttonStyle}`}
          onClick={onButtonClick}
        >
          {buttonIcon || buttonLabel}
        </Button>
      </div>
    </div>
  );
}
